import React from 'react';
import { Card, CardProps } from '@mantine/core';

interface BenchCardProps extends CardProps {
    children: React.ReactNode;
}

/**
 * Reusable Card component for Bench Admin with premium default styles.
 * All Mantine Card props are supported and will override defaults if provided.
 */
const BenchCard: React.FC<BenchCardProps> = ({
    children,
    p = "xl",
    radius = "lg",
    my = "md",
    // shadow = "rgba(0, 0, 0, 0.1) 0px 4px 12px",
     sx,
    ...others
}) => {
    return (
        <Card
            withBorder
            // shadow={shadow}
            p={p}
            radius={radius}
            my={my}
            // Default styles merge with custom sx prop
            sx={[
                {
                    backgroundColor: "white",
                    border: "none",
                    overflow: "visible",
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
            {...others}
        >
            {children}
        </Card>
    );
};

export default BenchCard;